
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  Connection,
} from '@/types';
import CancelledConnectionsDialog from './CancelledConnectionsDialog.vue';

moment.locale('it');

@Component({
  components: {
    CancelledConnectionsDialog,
  },
})
export default class CancelledConnections extends Vue {
  @Prop(Object) readonly connection!: Connection;

  loading = false
  editDialog = false

  get isDisabled() {
    return this.loading;
  }

  get hasCancelledConnections(): boolean {
    return this.connection.cancelledConnections > 0;
  }

  get cancelledConnections(): number {
    return this.connection.cancelledConnections;
  }

  get tooltipText(): string {
    return this.cancelledConnections === 1
      ? '1 pratica archiviata'
      : `${this.cancelledConnections} pratiche archiviate`;
  }

  async onEdit() {
    // Non permette l'apertura del dialog durante il caricamento
    if (this.loading || this.isDisabled) return;

    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    // La connessione deve esistere per procedere
    if (this.connection) {
      // Seleziona la Connection prima di aprire il dialog
      this.loading = true;
      await this.$store.dispatch('selectConnection', { id: this.connection.id });
      this.editDialog = true;
      this.loading = false;
    }
  }
}

